import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WhatsappImagesComponent } from './whatsapp-images.component';

const routes: Routes = [{ path: '', component: WhatsappImagesComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WhatsappImagesRoutingModule { }
